// extracted by mini-css-extract-plugin
module.exports = {"root":"TipsAndArticles_root__SduIM","title":"TipsAndArticles_title__oKH0b","tips":"TipsAndArticles_tips__V_o9_"};